export const actionsMode = {
    lightMode: 'light'
};

export default actionsMode;